import React, { Component } from "react";
import { Form, Button } from "semantic-ui-react";
import InlineError from "../messages/InlineError";

function isInteger(value) {
  if (typeof value !== "string") return false;
  return (
    !isNaN(value) &&
    // parseInt(Number(value), 10) === value &&
    !isNaN(parseInt(value, 10))
  );
}

class SecurityTokenForm extends Component {
  constructor(props) {
    super(props);
    const { token } = this.props;
    this.state = {
      token,
      error: props.error,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.error !== nextProps.error) {
      this.setState({ error: nextProps.error });
    }
  }

  onChange = (e) =>
    this.setState({
      token: e.target.value,
      error: "",
    });

  onSubmit = () => {
    const { token } = this.state;
    if (token && token !== "" && isInteger(token)) {
      this.setState({ error: undefined });
      this.props.submit(token);
    } else {
      this.setState({ error: "Invalid security code" });
    }
  };

  render() {
    const { error, token } = this.state;
    return (
      <Form onSubmit={this.onSubmit} loading={this.props.loading}>
        <Form.Field error={error}>
          <label htmlFor="token">Please enter security code</label>
          <input
            type="text"
            id="token"
            name="token"
            placeholder="Code"
            // value={token}
            onChange={this.onChange}
            defaultValue={token}
          />
          {error && <InlineError text={error} />}
        </Form.Field>
        <Button primary>Submit</Button>
      </Form>
    );
  }
}

export default SecurityTokenForm;



// WEBPACK FOOTER //
// ./src/components/forms/SecurityTokenForm.js